module.exports = __webpack_public_path__ + "static/media/4ODA13.2b4854a9.jpg";